import Splide from '@splidejs/splide'

const splideWrapper = (data) => ({
    ...data,

    // A banner counts as seen once per page view.
    //
    // The carousel autoplays on a permanent loop, and Splide's "moved" event
    // fires on every transition including the automatic ones. Without this,
    // an idle homepage pushed a fresh gtm_banner_view every few seconds for
    // as long as the tab stayed open - tens of events per visitor, all for
    // banners they had already been counted as seeing.
    seenBanners: new Set(),

    // Returns the alt text the first time a banner is seen, and null after
    // that. Also guards the slide having no image at all, which would
    // previously have thrown.
    firstViewOf(slide) {
        const alt = slide?.getElementsByTagName('img')?.[0]?.getAttribute('alt')

        if (!alt || this.seenBanners.has(alt)) {
            return null
        }

        this.seenBanners.add(alt)

        return alt
    },

    init() {
      if (document.getElementsByClassName('splide').length) {
          const eligible = window.accuEligibleCheck({})
          const numOfSlides = document.getElementsByClassName('splide__slide').length
          eligible.accuEligible()

          window.splide = new Splide('.splide', {
              autoplay: true,
              type: 'loop', // permanently loop , seems cannot be changed and is readonly
              pauseOnHover: true,
              pauseOnFocus: false,
              rewind: !!(
                  numOfSlides > 2 ||
                  (numOfSlides === 2 && eligible.isEligible === true)
              ),
          })

          window.splide.on('moved', newIndex => {
              const slide = window.splide.Components.Slides.getAt(newIndex)
              const alt = this.firstViewOf(slide?.slide)

              if (!alt) {
                  return
              }

              window.dispatchEvent(
                  new CustomEvent('gtmdata', {
                      detail: {
                          event: 'gtm_banner_view',
                          payload: {
                              banner_alt: `${alt} banner shown`,
                              banner_position: newIndex,
                          },
                      },
                  }),
              )
          })

          window.splide.on('click', slide => {
              window.dispatchEvent(
                  new CustomEvent('gtmdata', {
                      detail: {
                          event: 'gtm_banner_click',
                          payload: {
                              banner_alt: `${slide.slide.getElementsByTagName('img')[0].getAttribute('alt')} banner clicked`,
                              banner_position: window.splide.index,
                          },
                      },
                  }),
              )
          })

          window.splide.mount()
          window.dispatchEvent(new CustomEvent('splide-mounted'))

          if (eligible.isEligible === false) {
              window.splide.remove('.accu_slide_handle')
          }

          if (
              numOfSlides > 2 ||
              (numOfSlides === 2 && eligible.isEligible === true)
          ) {
              document.getElementsByClassName('splide__arrows')[0].style.display =
                  'block'
          } else {
              document.getElementsByClassName('splide__arrows')[0].style.display =
                  'none'
          }
      }

    },
    refreshOnChange(initial = false) {
        // check every banner option and decide
        const eligibleCheck = window.accuEligibleCheck({})
        eligibleCheck.accuEligible()
        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))
        let eligibleCount = 0
        Object.keys(options).forEach((key, index) => {
            window.splide.remove(`.accu_slide_handle_${options[key].id}`)
            if (eligibleCheck.isEligibleFor(options[key].id)) {
                // index position is dependable on how many hardcoded entries we want before accupro
                window.splide.add(options[key].markup, eligibleCount + 1)
                eligibleCount += 1
                if (window.splide.Components.Slides.getLength(true) > 1) {
                    window.splide.rewind = true
                    document.getElementsByClassName('splide__arrows')[0].style.display = 'block'
                }
            } else if (window.splide.Components.Slides.getLength(true) === 1) {
                window.splide.rewind = false
                document.getElementsByClassName('splide__arrows')[0].style.display = 'none'
            }
        })

        if (initial || window.splide.index === (eligibleCount - 1 + 0)) {
            const current = window.splide.Components.Slides.getAt(window.splide.index)
            const alt = this.firstViewOf(current?.slide)

            if (alt) {
                window.dataLayer.push({
                    event: 'gtm_banner_view',
                    payload: {
                        banner_alt: `${alt} banner shown`,
                        banner_position: window.splide.index,
                    },
                })
            }
        }
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('splideWrapper', splideWrapper)
})
